export default {
    SET_VALUE_PRODUCT_LIST: 'SET_VALUE_PRODUCT_LIST',
    SET_VALUE_DETAIL_PRICES:'SET_VALUE_DETAIL_PRICES',
    SET_VALUE_MODEL_LIST: 'SET_VALUE_MODEL_LIST',
};